import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'transformCurrency'
})
export class TransformCurrencyPiPe implements PipeTransform {
    transform(value, listItem, param = 'code') {
        const item = listItem ? listItem.find(p => p.id === value) : value;
        const substrCountryCode = (item[param].length <= 2 ? item[param] : item[param].substring(0, 2)).toLowerCase();
        const flag = `flag-icon flag-icon-${substrCountryCode}`;
        return !item ? '' : `<span class="${flag}"></span>&nbsp;<span>${item[param]}</span>`;
    }
}
